export const handleFacetOnChange = (facet, value, event) => {
  /*
   * We are trying to implement Radio Button also as a checkbox, why? Because if we don't users don't have a way to unselect the radio button.
   * So if a facet type is Radio like availability we take the first value from the input and set it as an input
   */
  const { target } = event;

  if (facet.type === 'RADIO') {
    const val = target._x_model.get();
    if (Array.isArray(val) && val.includes(value.label)) {
      target._x_model.set([value.label]);
    }
  }
};

const productsBrowserFacet = () => ({
  expanded: false,
  showAll: false,

  get label() {
    return this.facet.label;
  },

  get values() {
    return this.facet.values;
  },

  onChange(facet, value, event) {
    handleFacetOnChange(facet, value, event);
  },
});

export default productsBrowserFacet;
